import { Checkbox, FormControlLabel, FormGroup, Link, Typography } from "@mui/material";
import config from "config";

interface CommonProps {
  className?: string;
}

type ConditionalProps =
  | { withCheck: false; onCheck?: never; checked?: never }
  | {
      onCheck: () => void;
      checked: boolean;
      withCheck?: true;
    };

export type GdprConsentProps = CommonProps & ConditionalProps;

function GdprConsent(props: GdprConsentProps) {
  const { className, checked, onCheck, withCheck = true } = props;

  return withCheck ? (
    <FormGroup className={className}>
      <FormControlLabel
        control={<Checkbox value={checked} onClick={onCheck} />}
        label={
          <Typography variant='body2'>
            I have read and agree to the{" "}
            <Link href={config.links.termsAndConditions} rel='noopener noreferrer' target='_blank'>
              Terms and conditions
            </Link>{" "}
            and{" "}
            <Link href={config.links.privacyPolicy} rel='noopener noreferrer' target='_blank'>
              Privacy Policy
            </Link>
          </Typography>
        }
      />
    </FormGroup>
  ) : (
    <Typography align='center' variant='body2' className={className}>
      By signing in with Google you agree to the{" "}
      <Link href={config.links.termsAndConditions} rel='noopener noreferrer' target='_blank'>
        Terms and conditions
      </Link>{" "}
      and{" "}
      <Link href={config.links.privacyPolicy} rel='noopener noreferrer' target='_blank'>
        Privacy Policy
      </Link>
    </Typography>
  );
}

export default GdprConsent;
